import { useMarkdownStyle } from "../../components/markdown/MarkdownStyleContext";
import { markdownSizesFor } from "../../components/markdown/markdownSizes";
import { sameNodePosition, } from "../../components/markdown/utils";
import { cn } from "../../lib";
import { cva } from "class-variance-authority";
import React, { memo } from "react";
export const ulBlockVariants = cva("pb-2 flex flex-col gap-1", {
    variants: {
        taskList: {
            false: "list-disc pl-6",
            true: "",
        },
    },
    defaultVariants: {
        taskList: false,
    },
});
export const UlBlock = memo(({ children, className }) => {
    const { textColor, forcedTextSize, textSize: size } = useMarkdownStyle();
    const textSize = forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownSizesFor(size).paragraph;
    const isTaskList = className === null || className === void 0 ? void 0 : className.includes("contains-task-list");
    return (React.createElement("ul", { className: cn(ulBlockVariants({ taskList: isTaskList }), textColor, textSize, className) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.className === next.className);
UlBlock.displayName = "UlBlock";
export const olBlockVariants = cva([
    "list-decimal pb-2 pl-6 flex flex-col gap-1",
]);
export const OlBlock = memo(({ children, start }) => {
    const { textColor, forcedTextSize, textSize: size } = useMarkdownStyle();
    const textSize = forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownSizesFor(size).paragraph;
    return (React.createElement("ol", { start: start, className: cn(olBlockVariants(), textColor, textSize) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.start === next.start);
OlBlock.displayName = "OlBlock";
export const liBlockVariants = cva(["break-words"]);
export const LiBlock = memo(({ children, className }) => {
    const { textColor, forcedTextSize, textSize: size } = useMarkdownStyle();
    const textSize = forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownSizesFor(size).paragraph;
    const isTaskListItem = className === null || className === void 0 ? void 0 : className.includes("task-list-item");
    return (React.createElement("li", { className: cn(liBlockVariants(), isTaskListItem && "list-none", textColor, textSize, className) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.className === next.className);
LiBlock.displayName = "LiBlock";
//# sourceMappingURL=List.js.map